import { Injectable } from '@angular/core';
import { map, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ResizeService {
  private resizeSubject: Subject<number> = new Subject();

  public isMobile$ = this.resizeSubject.asObservable().pipe(
    map((width) => {
      const mainPadding: number =
        parseInt(
          getComputedStyle(document.documentElement).getPropertyValue(
            '--main-padding'
          )
        ) * 2;
      const containerWidth = width - mainPadding;

      return containerWidth < 768;
    })
  );

  setWith(width: number): void {
    this.resizeSubject.next(width);
  }
}
